import DateUtils from 'utils/date';

const MensagensParaUsuarioFinal = {

  BloqueioFuncionalidade(termino) {
    const mensagemSemData = 'Acesso temporariamente indisponível devido à janela de Renovação de Assinaturas da Microsoft.';

    if (!termino) return mensagemSemData;

    const data = new Date(termino);
    if (isNaN(data.getTime())) return mensagemSemData;

    const hora = `${DateUtils.padTo2Digits(data.getHours())}:${DateUtils.padTo2Digits(data.getMinutes())}`;
    const dia = DateUtils.padTo2Digits(data.getDate());

    return `${mensagemSemData} A funcionalidade será restabelecida automaticamente após ${hora} horas do dia ${dia}.`;
  }

}

export default MensagensParaUsuarioFinal;